import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

export const getDayOverview = async (startDate, endDate, selectedEnvironment, selectedPackage, selectedFramework, selectedUnit, isCsqXp = null) => {
  try {
    // Convert 'All app packages' to 'app' for the API
    const packageParam = selectedPackage.toLowerCase() === 'all packages' ? 'app' : selectedPackage.toLowerCase();

    const body = {
      startDate,
      endDate,
      env: selectedEnvironment.toLowerCase(),
      package: packageParam,
      framework: selectedFramework.toLowerCase(),
      unit: selectedUnit.toLowerCase()
    };
    if (isCsqXp !== null) {
      body.isCsqXp = isCsqXp;
    }

    const response = await api({
      method: 'post',
      url: `${QUALITY_SERVICE_API_URL}/hub/test-history/day-results/overview`,
      headers: {},
      data: body
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching day overview:', error);
    throw error;
  }
};

